export default __webpack_public_path__ + "static/media/rk7.5261c5d7.png";